export var LensStates = {
  Loading: 'loading',
  Loaded: 'loaded',
  Active: 'active',
  Cleared: 'cleared',
  CreateError: 'createError',
  RefreshError: 'refreshError',
  ActiveError: 'activeError',
  CancelError: 'cancelError',
  ClearError: 'clearError'
};